import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  
  // For date-only strings (YYYY-MM-DD), treat as calendar date without timezone shift
  // Parse manually to avoid timezone conversion
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  
  // For full datetime strings, use standard parsing
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function calculateDaysRemaining(endDate) {
  if (!endDate) return 0;
  
  // For date-only strings, parse as calendar date
  let end;
  if (/^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
    const [year, month, day] = endDate.split('-').map(Number);
    end = new Date(year, month - 1, day);
  } else {
    end = new Date(endDate);
  }
  
  const now = new Date();
  const diff = end - now;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}